import { render, staticRenderFns } from "./changeParentDialog.vue?vue&type=template&id=6a749fba&scoped=true&"
import script from "./changeParentDialog.vue?vue&type=script&lang=js&"
export * from "./changeParentDialog.vue?vue&type=script&lang=js&"
import style0 from "./changeParentDialog.vue?vue&type=style&index=0&id=6a749fba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a749fba",
  null
  
)

export default component.exports